"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lowerCaseObjectKeys = void 0;
var _lodash = _interopRequireDefault(require("lodash.lowerfirst"));
const lowerCaseObjectKeys = object => Object.fromEntries(Object.entries(object).map(([key, value]) => [(0, _lodash.default)(key), value]));
exports.lowerCaseObjectKeys = lowerCaseObjectKeys;
